enum SyncStatus {
  None = "None",
  //Started,
  InProgress = "InProgress",
  Completed = "Completed",
  Error = "Error",
  Cancelled = "Cancelled",
}

export default SyncStatus;
